import React, { useEffect, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { FreeTrialModalIcon } from '../../../components/icons';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { trackDwebEvent } from '../../analytics';
import { connect } from "react-redux";
import { freeTrailShown } from "../../../store/actions/paymentsActionCreator";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: 307
  },
  trialDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  trialDaysDesc: {
    fontSize: 31,
    color: "#000000"
  },
  trialDays: {
    fontSize: 38,
    color: "#de1c22"
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 20,
    fontSize: 18,
    fontWeight: 600,
    color: '#000',
  },
  dialogAction: {
    justifyContent: 'center',
    paddingTop: 40,
    paddingBottom: 40
  },
  btn: {
    backgroundColor: '#00875a',
    padding: "7px 44px 6px 45px",
    borderRadius: 4,
    borderColor: '#00875a',
    textTransform: 'capitalize'
  },
  widthV1: {
    maxWidth: 700
  }
}));
const FreeTrialAlertsDialog = ({ user, payments, dispatchFreeTrailShown, cancelText, confirmText, status, confirmMessage, confirmTitle, onConfirm, confirmOpen, onClose }) => {

  const [open, setOpen] = React.useState(confirmOpen);
  const [userInfo, setUserInfo] = useState({});
  const classes = useStyles();

  useEffect(() => {
    if (open) {
      trackDwebEvent("Dweb Subscription Reminder Modal Opened", {
        free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
        days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
      });
      dispatchFreeTrailShown(true)
    }
  }, [open]);

  useEffect(() => {

    if (user.userInfo) {
      setUserInfo(user.userInfo);
    }

  }, [user.userInfo]);

  const handleNo = () => {
    setOpen(false)
    onClose(false);
  };
  const handleYes = () => {
    trackDwebEvent("Dweb Subscription Reminder Go Premium ", {
      free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
      days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
    });
    setOpen(false);
    onConfirm(true);
  };
  const handleClose = () => {
    trackDwebEvent("Dweb Subscription Reminder Modal Closed", {
      free_trial_start_date: payments && payments.subscriptionStatus && payments.subscriptionStatus.subscriptionStartDateEpoch ? payments.subscriptionStatus.subscriptionStartDateEpoch : "",
      days_to_free_trial_expiry: payments && payments.subscriptionStatus && payments.subscriptionStatus.numberOfDays ? payments.subscriptionStatus.numberOfDays : "",
    });
    setOpen(false)
    onClose(false);
  }
  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth={'sm'}
        TransitionComponent={Transition}
        keepMounted
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        onClose={handleClose}
        aria-labelledby="free-trial-alert-dialog-slide-title"
        aria-describedby="free-trial-alert-dialog-slide-description"
        classes={{ paperWidthSm: classes.widthV1 }}
      >
        <DialogTitle id="free-trial-alert-dialog-slide-title" onClose={handleClose}>
          {/* <Typography variant="h6">{""}</Typography> */}
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className={classes.trialDiv}>
            <div>
              <FreeTrialModalIcon className={classes.icon} />
            </div>
            <div>
              <h6 className={classes.trialDaysDesc}>Your {status
                && status.status &&
                status.subscriptionType
                && (status.status == "ACTIVE" || status.status == "EXPIRED")
                && status.subscriptionType == "PAID" ? "Subscription" : "Free Trial"} Period {!status.isExpired ? "Expires" : 'Expired'} {!status.isExpired && <span className={classes.trialDays}>{status.numberOfDays ? status.numberOfDays > 1 ? " in " + status.numberOfDays + ' Days' : " in " + status.numberOfDays + ' Day' : "Today"}</span>}</h6>
            </div>
          </div>
        </DialogContent>
        {userInfo && userInfo.role != "USER" &&
          <DialogActions className={classes.dialogAction}>
            <Button onClick={handleYes} variant="contained" className={classes.btn} color="primary">
              {confirmText ? confirmText : 'Go Premium'}
            </Button>
          </DialogActions>
        }
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchFreeTrailShown: (value) => {
    dispatch(freeTrailShown(value))
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FreeTrialAlertsDialog);